import { useLocation, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

export const useNavigateToAudienceEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(
    ({ sqid }: { sqid: string }) => {
      void navigate({
        to: "/settings/admin/audience/$sqid",
        params: {
          sqid,
        },
        state: {
          from: { ...location, search: location.searchStr },
        },
      });
    },
    [location, navigate],
  );
};
